import { styled } from '@mui/material';

export const Wrapper = styled('main')`
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;

    .right-section {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        padding: ${({ theme }) => theme.spacing(3)};
        position: relative;
        &-profile {
            background-color: ${({ theme }) => theme.palette.background.default};
        }
    }
`;
